import { JSX } from "react";
import { isArray } from "common";
import { Children } from "common/types/children";

export const isChildren = isArray<Children, JSX.Element[]>();

export const getChildren = (children: Children = []): JSX.Element[] =>
  isChildren(children) ? children : [children];
